import React, { useEffect } from "react";
import PageTitle from "./pageTitle";

export default function NotFound() {
  useEffect(() => {
    PageTitle("NOT_FOUND");
  }, []);
 const handleGoHome = () => {
    const path = window.location.pathname;
    if (path.startsWith("/app")) {
      window.location.href = "/app";
    } else {
      window.location.href = "/";
    }
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "80vh",
        width: "100%",
        backgroundColor: "#ffffff",
        color: "#333",
        textAlign: "center",
      }}
    >
      <div
        style={{
          fontSize: "72px",
          fontWeight: "bold",
          color: "#414141",
          marginBottom: "16px",
        }}
      >
        <span role="img" aria-label="Warning">
          ⚠️
        </span>{" "}
        404
      </div>
      <div
        style={{
          fontSize: "32px",
          color: "#555",
          marginBottom: "8px",
        }}
      >
        Page Not Found
      </div>
      <div
        style={{
          fontSize: "16px",
          color: "#777",
        }}
      >
        The page you're looking for doesn’t exist or has been moved.
      </div>
      <button
        onClick={handleGoHome}
        style={{
          marginTop: "24px",
          padding: "10px 20px",
          backgroundColor: "#414141",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Go Home
      </button>
    </div>
  );
}
